<nav class="w-full py-4 sm:py-6" [attr.aria-label]="'Nawigacja składania zamówienia' | translate">
  <div class="hidden sm:grid sm:grid-cols-[1fr_auto_1fr] sm:items-center">
    <button
      type="button"
      class="inline-flex h-12 w-fit items-center gap-2 rounded-lg border border-gray-200 bg-white px-5 text-sm font-semibold text-gray-700 transition-colors hover:border-gray-300 hover:bg-gray-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brocom-orange focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-40"
      [disabled]="currentStep === 1"
      (click)="handleStepChange(-1)"
    >
      <svg aria-hidden="true" class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m15 19-7-7 7-7"></path>
      </svg>
      <span>{{ 'Wstecz' | translate }}</span>
    </button>

    <div class="flex items-center justify-center gap-3 text-sm text-gray-600" role="group" [attr.aria-label]="'Postęp składania zamówienia' | translate">
      <span>{{ 'Krok' | translate }} <span class="font-semibold text-gray-900">{{ currentStep }}</span> {{ 'z' | translate }} {{ steps.length }}</span>
      <div class="flex items-center gap-1.5" aria-hidden="true">
        <span
          *ngFor="let step of steps; let i = index"
          class="h-2 rounded-full transition-all duration-200"
          [class.w-4]="i + 1 === currentStep"
          [class.w-2]="i + 1 !== currentStep"
          [class.bg-brocom-orange]="i + 1 <= currentStep"
          [class.bg-gray-200]="i + 1 > currentStep"
        ></span>
      </div>
    </div>

    <button
      *ngIf="currentStep !== 2 && currentStep < steps.length"
      type="button"
      [disabled]="isNextDisabled"
      class="group inline-flex h-12 w-fit items-center justify-self-end gap-2 rounded-lg bg-brocom-orange px-6 text-sm font-semibold text-white transition-colors hover:bg-brocom-orange-dark focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brocom-orange focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
      (click)="handleStepChange(1)"
    >
      <span>{{ 'Dalej' | translate }}</span>
      <svg aria-hidden="true" class="h-4 w-4 transition-transform group-hover:translate-x-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m9 5 7 7-7 7"></path>
      </svg>
    </button>
  </div>

  <div class="space-y-4 sm:hidden">
    <div class="flex items-center justify-center gap-3 text-sm text-gray-600" role="group" [attr.aria-label]="'Postęp składania zamówienia' | translate">
      <span>{{ 'Krok' | translate }} <span class="font-semibold text-gray-900">{{ currentStep }}</span> {{ 'z' | translate }} {{ steps.length }}</span>
      <span class="font-medium text-gray-900">{{ steps[currentStep - 1]?.name }}</span>
    </div>

    <div class="flex items-center gap-3">
      <button
        type="button"
        class="inline-flex h-11 flex-1 items-center justify-center gap-2 rounded-lg border border-gray-200 bg-white px-4 text-sm font-semibold text-gray-700 transition-colors hover:bg-gray-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brocom-orange focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-40"
        [class.w-full]="currentStep === 2 || currentStep === steps.length"
        [class.flex-none]="currentStep === 2 || currentStep === steps.length"
        [disabled]="currentStep === 1"
        (click)="handleStepChange(-1)"
      >
        <svg aria-hidden="true" class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m15 19-7-7 7-7"></path>
        </svg>
        <span>{{ 'Wstecz' | translate }}</span>
      </button>

      <button
        *ngIf="currentStep !== 2 && currentStep < steps.length"
        type="button"
        [disabled]="isNextDisabled"
        class="group inline-flex h-11 flex-1 items-center justify-center gap-2 rounded-lg bg-brocom-orange px-4 text-sm font-semibold text-white transition-colors hover:bg-brocom-orange-dark focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brocom-orange focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
        (click)="handleStepChange(1)"
      >
        <span>{{ 'Dalej' | translate }}</span>
        <svg aria-hidden="true" class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m9 5 7 7-7 7"></path>
        </svg>
      </button>
    </div>
  </div>
</nav>
